import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

const ArtistsPage = () => {
  const { letter } = useParams();
  const [artists, setArtists] = useState(null);

  useEffect(() => {
    if (!letter) return;
    // Scroll to top when letter changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
    fetch(`/api/artists/${letter}`)
      .then((res) => res.json())
      .then((data) => setArtists(data));
  }, [letter]);

  if (!letter) {
    const letters = [
      ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      ...'0123456789',
      '-'
    ];
    return (
      <div className="p-4">
        <h1 className="text-xl font-bold mb-4">Browse Artists</h1>
        <div className="flex flex-wrap gap-3">
          {letters.map((ltr) => (
            <Link
              key={ltr}
              to={`/artists/${ltr.toLowerCase()}`}
              className="text-blue-700 hover:underline"
            >
              {ltr}
            </Link>
          ))}
        </div>
      </div>
    );
  }

  if (!artists) return <p className="p-4">Loading…</p>;

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h1 className="text-xl font-bold mb-4">
        Artists starting with: {letter.toUpperCase()}
      </h1>
      <ul className="space-y-2">
        {Object.entries(artists).map(([handle, meta]) => (
          <li key={meta.id}>
            <Link to={`/artist/${meta.id}`} className="text-blue-700 hover:underline font-medium">
              {handle}
            </Link>{' '}
            {meta.name && <span className="text-gray-600">({meta.name})</span>}
            {meta.countrycode && <span className="ml-2">🌍 {meta.countrycode.toUpperCase()}</span>}
            <span className="ml-2 text-sm text-gray-500">🎵 {meta.song_count} song{meta.song_count !== 1 && 's'}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ArtistsPage;

